import { render, staticRenderFns } from "./_.vue?vue&type=template&id=4bf2e06a&"
import script from "./_.vue?vue&type=script&lang=js&"
export * from "./_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CmsPage: require('/var/www/k9-frontend/k9-front-20261006142511/node_modules/sitis-nuxt/lib/cms/CmsPage.vue').default})
